import { render, staticRenderFns } from "./OrderShareDetails.vue?vue&type=template&id=ab0ad104"
import script from "./OrderShareDetails.vue?vue&type=script&lang=js"
export * from "./OrderShareDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderShareDetails.vue?vue&type=style&index=0&id=ab0ad104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports